import { NormalizedConditions } from '~/features/shared/search/shop/types'

export const countFilteredConditions = ({
  shopType = 'all',
  brand,
  searchWord = '',
}: Partial<NormalizedConditions>): number => {
  let result = 0
  if (brand !== undefined) result += 1
  if (shopType !== 'all') result += 1
  result += searchWord.split(/\s+/g).filter((w) => w).length
  return result
}
